import React from 'react'

import Header from "../Global/Header"
import Sidebar from "../Global/Sidebar"
import Footer from "../Global/Footer"
import Content from "../Global/content"
import PartnerBanner from "../Global/PartnerBanner"
import ExpiredPlanBanner from "../Global/ExpiredPlanBanner"
import ImpersonationBanner from "../Global/ImpersonationBanner"

import { withRouter } from "react-router-dom"
import useContadorCheck from "../../hooks/useContadorCheck"

const Layout = (props) => {
    const { esContador, loading } = useContadorCheck()

    return(
        <React.Fragment>
            <ImpersonationBanner />
            <Sidebar />
            <div className="content">
                {!loading && esContador && <PartnerBanner />}
                <ExpiredPlanBanner />
                <Header title="Timbrát" />
                <Content body={props.children} />
            </div>
            <Footer />
        </React.Fragment>
    )
}

export default withRouter(Layout)